import { useCallback, useEffect, useRef, useState } from 'react';

const UNSAVED_WARNING_DURATION_MS = 7000;

const useTimedUnsavedWarning = () => {
  const [unsavedWarningVisible, setUnsavedWarningVisible] = useState(false);
  const timerRef = useRef(null);
  const generationRef = useRef(0);

  const clearUnsavedWarning = useCallback(() => {
    generationRef.current += 1;
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    timerRef.current = null;
    setUnsavedWarningVisible(false);
  }, []);

  const showUnsavedWarning = useCallback(() => {
    generationRef.current += 1;
    const generation = generationRef.current;
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    setUnsavedWarningVisible(true);
    timerRef.current = window.setTimeout(() => {
      if (generationRef.current !== generation) return;
      timerRef.current = null;
      setUnsavedWarningVisible(false);
    }, UNSAVED_WARNING_DURATION_MS);
  }, []);

  useEffect(() => () => {
    generationRef.current += 1;
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);

  return { unsavedWarningVisible, showUnsavedWarning, clearUnsavedWarning };
};

export default useTimedUnsavedWarning;
